import { render, staticRenderFns } from "./DoubleMatPuzzleFrame.vue?vue&type=template&id=341b5064&scoped=true&"
import script from "./DoubleMatPuzzleFrame.vue?vue&type=script&lang=ts&"
export * from "./DoubleMatPuzzleFrame.vue?vue&type=script&lang=ts&"
import style0 from "./DoubleMatPuzzleFrame.vue?vue&type=style&index=0&id=341b5064&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "341b5064",
  null
  
)

export default component.exports